import React, { useState, useCallback, useRef, useEffect } from 'react'
import Layout from '../../../components/Admin/Layout'
import Loading from '../../../components/shared/Loading'

import './QueryLPN.scss'
import InputField from '../../../components/shared/InputField'
import CustomTable from '../../../components/Admin/CustomTable'
import CustomizedBtn from '../../../components/Admin/CustomizedBtn'
import { Collapse, useEventCallback } from '@material-ui/core'
import InputDate from '../../../components/Admin/InputDate'
import CustomizeSelect from '../../../components/Admin/CustomizeSelect'
import AdminService from '../../../services/AdminServices'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CustomSelect from '../../../components/shared/CustomSelect'
import FileDownload from 'js-file-download'
import SimpleModal from '../../../components/shared/MessageModal'
import moment from 'moment'
// import PropTypes from 'prop-types'

// const rowsExample = [
//   { checked: false, lpn: { value: 'MKP3171861434', sku: '2018238318178P', seller: 'SMART PERU', cantidad: 2, cliente: 'CARLOS JOSE PACHECO RODRIGUEZ', codigo_de_barras: '21028000985125110001', sucursal: '1093 - TAMBO LIMATAMBO', }, order: '2113785', saleDate: '13-05-2020 10:30 a.m.', dispatchDate: '13-05-2020 1:45 a.m.', pickupDate: '21-05-2020 1:45pm', state: 'Pendiente', Etiqueta: '' },
//   { checked: false, lpn: { value: 'MKP3171861434', sku: '2018238318178P', seller: 'SMART PERU', cantidad: 2, cliente: 'CARLOS JOSE PACHECO RODRIGUEZ', codigo_de_barras: '21028000985125110001', sucursal: '1093 - TAMBO LIMATAMBO', }, order: '2113785', saleDate: '13-05-2020 10:30 a.m.', dispatchDate: '13-05-2020 1:45 a.m.', pickupDate: '21-05-2020 1:45pm', state: 'Pendiente', Etiqueta: '' },
//   { checked: false, lpn: { value: 'MKP3171861434', sku: '2018238318178P', seller: 'SMART PERU', cantidad: 2, cliente: 'CARLOS JOSE PACHECO RODRIGUEZ', codigo_de_barras: '21028000985125110001', sucursal: '1093 - TAMBO LIMATAMBO', }, order: '2113785', saleDate: '13-05-2020 10:30 a.m.', dispatchDate: '13-05-2020 1:45 a.m.', pickupDate: '21-05-2020 1:45pm', state: 'Pendiente', Etiqueta: '' },
//   { checked: false, lpn: { value: 'MKP3171861434', sku: '2018238318178P', seller: 'SMART PERU', cantidad: 2, cliente: 'CARLOS JOSE PACHECO RODRIGUEZ', codigo_de_barras: '21028000985125110001', sucursal: '1093 - TAMBO LIMATAMBO', }, order: '2113785', saleDate: '13-05-2020 10:30 a.m.', dispatchDate: '13-05-2020 1:45 a.m.', pickupDate: '21-05-2020 1:45pm', state: 'Pendiente', Etiqueta: '' },
//   { checked: false, lpn: { value: 'MKP3171861434', sku: '2018238318178P', seller: 'SMART PERU', cantidad: 2, cliente: 'CARLOS JOSE PACHECO RODRIGUEZ', codigo_de_barras: '21028000985125110001', sucursal: '1093 - TAMBO LIMATAMBO', }, order: '2113785', saleDate: '13-05-2020 10:30 a.m.', dispatchDate: '13-05-2020 1:45 a.m.', pickupDate: '21-05-2020 1:45pm', state: 'Pendiente', Etiqueta: '' },
//   { checked: false, lpn: { value: 'MKP3171861434', sku: '2018238318178P', seller: 'SMART PERU', cantidad: 2, cliente: 'CARLOS JOSE PACHECO RODRIGUEZ', codigo_de_barras: '21028000985125110001', sucursal: '1093 - TAMBO LIMATAMBO', }, order: '2113785', saleDate: '13-05-2020 10:30 a.m.', dispatchDate: '13-05-2020 1:45 a.m.', pickupDate: '21-05-2020 1:45pm', state: 'Pendiente', Etiqueta: '' },
//   { checked: false, lpn: { value: 'MKP3171861434', sku: '2018238318178P', seller: 'SMART PERU', cantidad: 2, cliente: 'CARLOS JOSE PACHECO RODRIGUEZ', codigo_de_barras: '21028000985125110001', sucursal: '1093 - TAMBO LIMATAMBO', }, order: '2113785', saleDate: '13-05-2020 10:30 a.m.', dispatchDate: '13-05-2020 1:45 a.m.', pickupDate: '21-05-2020 1:45pm', state: 'Pendiente', Etiqueta: '' },
//   { checked: false, lpn: { value: 'MKP3171861434', sku: '2018238318178P', seller: 'SMART PERU', cantidad: 2, cliente: 'CARLOS JOSE PACHECO RODRIGUEZ', codigo_de_barras: '21028000985125110001', sucursal: '1093 - TAMBO LIMATAMBO', }, order: '2113785', saleDate: '13-05-2020 10:30 a.m.', dispatchDate: '13-05-2020 1:45 a.m.', pickupDate: '21-05-2020 1:45pm', state: 'Pendiente', Etiqueta: '' },
//   { checked: false, lpn: { value: 'MKP3171861434', sku: '2018238318178P', seller: 'SMART PERU', cantidad: 2, cliente: 'CARLOS JOSE PACHECO RODRIGUEZ', codigo_de_barras: '21028000985125110001', sucursal: '1093 - TAMBO LIMATAMBO', }, order: '2113785', saleDate: '13-05-2020 10:30 a.m.', dispatchDate: '13-05-2020 1:45 a.m.', pickupDate: '21-05-2020 1:45pm', state: 'Pendiente', Etiqueta: '' },
// ]

const BuildLPN = props => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalError, setModalError] = useState(false);
  const [total, setTotal] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [checkLPN, setCheckLPN] = useState([]);
  const [rows, setRows] = useState([]);
  const [countFilters, setCountFilters] = useState(0);
  const [openForm, setOpenForm] = useState(false);
  const [applyFilters, setFilters] = useState({ apply: false });
  const [form, setForm] = useState({
    state: [],
    startCreationDate: null,
    endCreationDate: null,
    startPickupDate: null,
    endPickupDate: null,
    startDispatchDate: null,
    endDispatchDate: null,
    orderNumber: ''
  })
  const didMounRef = useRef(false);

  const downloadExcel = async () => {
    try {
      setLoading(true);
      const data = await AdminService.downloadExcelLPN({
        ...(applyFilters.apply && { ...form }),
      })
      FileDownload(data, 'excel_LPN_MKTP.xlsx')
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setModalError(true);
      console.error(error)
    }
  }

  const formatStatus = (status) => {
    if (status == 'Pendiente') return (
      <span style={{ color: '#FF6868', textTransform: 'capitalize' }} >{status}</span>
    )
    else return (
      <span style={{ color: '#9240C9', textTransform: 'capitalize' }} >{status}</span>
    )
  }

  const formatDate = (date) => {
    if (date) return moment(date).format('DD-MM-YYYY hh:mm a');
    else return date;
  }

  const columns = [
    { id: 'lpn', label: 'LPN', minWidth: 150, hasPopup: true },
    { id: 'orderNumber', label: 'N° Pedido', minWidth: 120 },
    { id: 'creationDate', label: 'Fec. Venta', minWidth: 220, format: formatDate },
    { id: 'dispatchDate', label: 'Fec. Despacho', minWidth: 220, format: formatDate },
    { id: 'pickupDate', label: 'Fec. Recojo', minWidth: 220, format: formatDate },
    { id: 'status', label: 'Estado', minWidth: 120, format: formatStatus },
    { id: 'tag', label: 'Etiqueta', type: 'download', minWidth: 120 },
  ]

  useEffect(() => {
    // setRows(rowsExample);
    loadLPNS();
  }, [])

  useEffect(() => {
    loadLPNS();
  }, [applyFilters])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (perPage !== '') {
        if (didMounRef.current) onChangePerPage(perPage);
        else didMounRef.current = true;
        // console.log(numElem);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
  }, [perPage]);

  const formatLPNS = (lpns) => {
    return lpns.map(l => ({
      ...l,
      checked: checkLPN.includes(l.lpn),
      lpn: {
        value: l.lpn,
        sku: l.storeSku,
        seller: '',
        cantidad: l.quantity,
        cliente: `${l.clientFirstName} ${l.clientLastName}`,
        codigo_de_barras: '',
        sucursal: l.storeName
      },
      status: 'Pendiente'
    }))
  }

  const loadLPNS = async (perPage = 5, currentPage = 1) => {
    try {
      setLoading(true);
      const { total, rows } = await AdminService.getLPNS({
        ...(applyFilters.apply && { ...form }),
        paginate: true,
        currentPage,
        perPage: perPage || 5
      })
      console.log(rows);
      console.log('FORMATTED CUDS', formatLPNS(rows));
      setTotal(total)
      setRows(formatLPNS(rows));
      setTotalPages(Math.ceil(parseInt(total) / parseInt(perPage)))
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      setModalError(true);
    }
  }

  const clearForm = () => {
    setForm({
      state: [],
      startCreationDate: null,
      endCreationDate: null,
      startPickupDate: null,
      endPickupDate: null,
      startDispatchDate: null,
      endDispatchDate: null,
      orderNumber: ''
      // applied: false
    })
    setCountFilters(0);
    // loadExpiredCuds();
  }

  const handleChange = async (evt, name) => {
    let newForm = { ...form }
    let value = evt.target ? evt.target.value : evt;
    const key = evt.target ? evt.target.name : name;
    setForm({
      ...newForm,
      [key]: value
    })
  }

  const countFiltersFilled = () => {
    let count = Object.keys(form).length;
    // console.log(count);
    for (const key in form) {
      if (form[key] === "" || form[key] === null) count -= 1
      else if (Array.isArray(form[key]) && form[key].length <= 0) count -= 1
    }
    return count;
  }

  const handleFilters = async () => {
    setOpenForm(false);
    const count = countFiltersFilled();
    setCountFilters(count);
    // setForm({...form, applied: true})
    setCheckLPN([]);
    setPerPage(5);
    setCurrentPage(1);
    setFilters({ apply: true });
  }

  const clearFilters = () => {
    setOpenForm(false);
    clearForm();
    setPerPage(5);
    setCurrentPage(1);
    setCheckLPN([]);
    setFilters({ apply: false });
  }

  const onChangePerPage = async (perPage) => {
    if (perPage <= 0) return;
    setCurrentPage(1);
    await loadLPNS(perPage, 1)
  }

  const onChangePage = async (numPage, perPage) => {
    setCurrentPage(numPage);
    loadLPNS(perPage, numPage)
  }

  const handleClickCheckbox = (row, rowIndex) => {
    const newRows = [...rows];
    newRows[rowIndex] = { ...row, checked: !newRows[rowIndex]['checked'] };
    console.log(newRows);
    setRows(newRows);
    // console.log(newRows.map(nr => nr.lpn['value']));
    const rowsUnChecked = newRows.filter(nr => !nr.checked);
    let newCheckLPN = [...checkLPN];
    newCheckLPN.forEach((ncLPN, i) => {
      const rowsUnCheckedFounded = rowsUnChecked.find(ruck => ruck['lpn']['value'] === ncLPN)
      if(rowsUnCheckedFounded) newCheckLPN.splice(i, 1);
    });
    setCheckLPN([
      ...newCheckLPN,
      ...newRows.filter(n => n.checked && !checkLPN.includes(n.lpn['value'])).map(nr => nr.lpn['value'])
    ]);
  }

  const checkRowsChecked = () => {
    // const isAnyRowChecked = rows.some(r => r.checked === true);
    // console.log(isAnyRowChecked);
    return checkLPN.length<=0 ? true : false;
  }

  return (
    <Layout>
      <SimpleModal
        visible={modalError}
        type={1}
        closeModal={() => setModalError(false)}
        message={'Ha ocurrido un error al conectar con el servidor, porfavor intente nuevamente o mas tarde.'}
      />
      <div className='BuildLPN-container'>
        <Loading visible={loading} />
        <div className='BuildLPN-title'>Consulta de LPNs</div>
        <div className='BuildLPN-filters'>
          <div className='BuildLPN-filters-header'>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span className='BuildLPN-label-bold'>Filtros</span>
              <span className='BuildLPN-filters-header-subtitle'>{countFilters} filtros aplicados</span>
            </div>
            {
              !openForm
                ? <ExpandMoreIcon onClick={() => setOpenForm(true)} fontSize='large' style={{ color: '#FF6868', cursor: 'pointer' }} />
                : <ExpandLessIcon onClick={() => setOpenForm(false)} fontSize='large' style={{ color: '#FF6868', cursor: 'pointer' }} />
            }
          </div>
          <Collapse in={openForm}>
            <form className='BuildLPN-form'>
              <div className='BuildLPN-form-field small'>
                <CustomSelect
                  label='Estado'
                  labelMargin='.5em'
                  name='state'
                  value={form.state}
                  handleChange={handleChange}
                  multiple={true}
                  countSelected
                  noMargin
                  // checkbox
                  options={[
                    { value: 'Pendiente', label: 'Pendiente' },
                    { value: 'Programado', label: 'Programado' },
                  ]}
                />
              </div>
              <div className='BuildLPN-form-field small'>
                <InputDate
                  value={form.startCreationDate}
                  handleChange={(e) => handleChange(e, 'startCreationDate')}
                  label='Fec. Venta (Inicio)'
                  fullWidth
                />
              </div>
              <div className='BuildLPN-form-field small'>
                <InputDate
                  value={form.startPickupDate}
                  handleChange={(e) => handleChange(e, 'startPickupDate')}
                  label='Fec. Recojo (Inicio)'
                  fullWidth
                />
              </div>
              <div className='BuildLPN-form-field small'>
                <InputDate
                  value={form.startDispatchDate}
                  handleChange={(e) => handleChange(e, 'startDispatchDate')}
                  label='Fec. despacho (Inicio)'
                  fullWidth
                />
              </div>
              <div className='BuildLPN-form-field small'>
                <InputField
                  name='orderNumber'
                  value={form.orderNumber}
                  handleChange={handleChange}
                  label='N° Pedido'
                  fullWidth
                  inputType='textfield'
                />
              </div>
              <div className='BuildLPN-form-field small'>
                <InputDate
                  value={form.endCreationDate}
                  handleChange={(e) => handleChange(e, 'endCreationDate')}
                  label='Fec. Venta (Fin)'
                  fullWidth
                  disabled={!form.startCreationDate}
                  minDate={form.startCreationDate}
                  minDateMessage='La fecha final debe ser despues del inicio'
                />
              </div>
              <div className='BuildLPN-form-field small'>
                <InputDate
                  value={form.endPickupDate}
                  handleChange={(e) => handleChange(e, 'endPickupDate')}
                  label='Fec. Recojo (Fin)'
                  fullWidth
                  disabled={!form.startPickupDate}
                  minDate={form.startPickupDate}
                  minDateMessage='La fecha final debe ser despues del inicio'
                />
              </div>
              <div className='BuildLPN-form-field small'>
                <InputDate
                  value={form.endDispatchDate}
                  handleChange={(e) => handleChange(e, 'endDispatchDate')}
                  label='Fec. Despacho (Fin)'
                  fullWidth
                  disabled={!form.startDispatchDate}
                  minDate={form.startDispatchDate}
                  minDateMessage='La fecha final debe ser despues del inicio'
                />
              </div>
              <div className='BuildLPN-form-footer'>
                <CustomizedBtn
                  margin='0'
                  outline={false}
                  padding='1em'
                  onClick={clearFilters}
                  size='medium'>
                  <span style={{ textTransform: 'none', letterSpacing: '0', margin: 0 }}>Limpiar filtros</span>
                </CustomizedBtn>
                <CustomizedBtn
                  filled
                  margin='0'
                  padding='1em'
                  onClick={handleFilters}
                  disabled={countFiltersFilled() <= 0}
                  size='medium'>
                  <span style={{ textTransform: 'none', letterSpacing: '0', margin: 0 }}>Aplicar filtros</span>
                </CustomizedBtn>
              </div>
            </form>
          </Collapse>
        </div>
        <div className='BuildLPN-report-header'>
          <span className='BuildLPN-label-bold'>Reporte</span>
          <div className='BuildLPN-report-header-buttons'>
            <CustomizedBtn
              filled
              margin='0 1em'
              padding='1em'
              onClick={() => console.log(checkLPN)}
              width='auto'
              color='#9240C9'
              disabled={checkRowsChecked()}
            >
              <span style={{ textTransform: 'none', letterSpacing: '0', margin: 0 }}>Descargar PDF seleccionados</span>
            </CustomizedBtn>
            <CustomizedBtn
              filled
              margin='0'
              padding='1em'
              onClick={downloadExcel}
              size='medium'
              color='#40C987'
            >
              <span style={{ textTransform: 'none', letterSpacing: '0', margin: 0 }}>Exportar a Excel</span>
            </CustomizedBtn>
          </div>
        </div>
        <div className='BuildLPN-report'>
          <CustomTable
            columns={columns}
            rows={rows}
            // onChangeNumElem={(num) => onChangePerPage(num)}
            total={total}
            currentPage={currentPage}
            changePage={onChangePage}
            perPage={perPage}
            onChangePerPage={(e) => setPerPage(e.target.value)}
            checkbox={true}
            onClickCheckBox={handleClickCheckbox}
            popUpColumns={2}
            totalPages={totalPages}
          />
        </div>
      </div>
    </Layout>
  )
}

BuildLPN.propTypes = {

}

export default BuildLPN
